import axiosInstance from "./utils";
import store from "../store";

export default {
  getAdminAccess(clientId) {
    return axiosInstance
      .get(`adminaccess/${clientId}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get admin access", err);
        store.dispatch("add_error_queue", {
          error: err,
          message:
            "Une erreur est survenu lors de la demande d'accès administrateur",
        });
      });
  },
};
